<bb-alert-ui class="bn-alert"
             [title]="title"
             [modifier]="alertTypeMapping[modifier]"
             [dismissible]="dismissible">
</bb-alert-ui>
